// «Получатели» of a «Рассылка» (stage J6): each letter of the run with its address, status, attempts and error.
import type { Id } from '@confdeck/core-shared';
import { LinkedTable } from '../record/LinkedTable.tsx';

export function CampaignLetters({ recordId }: { recordId: Id }) {
  return <LinkedTable recordId={recordId} field="messages" title="Письма рассылки" columns={['to', 'status', 'attempts', 'last_attempt', 'error']} empty="Писем нет" />;
}
